// removed by extract-text-webpack-plugin
module.exports = {"component":"D-aZDkXKdR-rzvbWnlVO7","column":"_1VXQlCYLq3hH1dcKW6bIUm","fullscreen":"_29cfwKK9T-Po3jHIzGvLyv","staticX":"iEciTrsjkBQLRBkScir-1","staticY":"_3J40W7Fthskj29sE3Mo9YZ","visibleScroll":"_D7Pk10gKtGSXDSU_QDO7","autoXScroll":"_7uwKhS9JeW8G5QLI35Y8d","mobileColumn":"_2gMYhd23SSZ-JjMS4-ZvUb","mobileReverse":"_35wBAsxkkZY1cNHVR_-1_Q"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Layout/Layout.css
// module id = 987
// module chunks = 0